import ZTable, { IColumnType, ITableRef } from '@/components/ZTable';
import { ModalWidth, formatDisplayFullDate } from '@/config';
import { TicketStatusType } from '@/constants';
import { getFullName } from '@/helpers/string';
import { Modal } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LianeBookingPagingDto, TicketPagingDto } from '@/__generated';

const columns: IColumnType<TicketPagingDto>[] = [
  {
    title: 'ticketBooking_TicketRefNo',
    dataIndex: 'ticketRefNo',
    sorter: true,
    ellipsis: true,
    width: 200,
  },
  {
    title: 'base.Status',
    dataIndex: 'ticketStatus',
    sorter: true,
    ellipsis: true,
    render: v => TicketStatusType.__getValue(v),
    width: 130,
  },
  {
    title: 'ticketBooking_Passenger',
    dataIndex: 'passengerFirstName',
    ellipsis: true,
    width: 180,
    render: (_, record) => getFullName(record.passengerFirstName, record.passengerLastName),
  },
  {
    title: 'ticketBooking_SeatNo',
    dataIndex: 'seatName',
    ellipsis: true,
    width: 80,
  },
  {
    title: 'ticketBooking_TicketClassName',
    dataIndex: 'ticketClassName',
    ellipsis: true,
    width: 130,
  },
  {
    title: 'bookingPage_TicketConditions',
    dataIndex: 'ticketConditionName',
    ellipsis: true,
    width: 180,
  },
  {
    title: 'ticketBooking_BookingDate',
    dataIndex: 'createdOn',
    width: 170,
    ellipsis: true,
    render: v => (v ? formatDisplayFullDate(v) : ''),
    sorter: true,
  },
];

type Props = {
  booking: LianeBookingPagingDto;
  onClose: () => void;
};

export default function TicketsModal({ booking, onClose }: Props) {
  const zTb = React.useRef<ITableRef>();
  const { t } = useTranslation();

  return (
    <Modal
      width={ModalWidth.extraLarge}
      title={t('bookingPage_Tickets')}
      onOk={onClose}
      okText={t('Close')}
      cancelButtonProps={{ style: { display: 'none' } }}
      open={true}
      onCancel={onClose}
    >
      {booking.bookingId ? (
        <ZTable<TicketPagingDto>
          columns={columns}
          primaryKey="id"
          tableRef={zTb}
          url="/liane-bookings/get-tickets"
          defaultFilter={{ LianeBookingId: booking.bookingId }}
          bordered
          order_by_asc={true}
          allowEdit={false}
          allowDelete={false}
          searchBtnAlignLeft
          actionColumnWidth={80}
        />
      ) : null}
    </Modal>
  );
}
